var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 22c-.85 0-1.683-.117-2.5-.35a8.442 8.442 0 0 1-2.3-1.05l1.45-1.45a6.81 6.81 0 0 0 1.625.638A7.036 7.036 0 0 0 13 20c1.95 0 3.604-.68 4.962-2.038C19.32 16.603 19.999 14.949 20 13c0-1.95-.68-3.604-2.038-4.963C16.603 6.678 14.949 5.999 13 6h-.15l1.55 1.55L13 9 9 5l4-4 1.4 1.45L12.85 4H13c2.5 0 4.625.875 6.375 2.625S22 10.5 22 13c0 1.25-.238 2.421-.713 3.513a9.16 9.16 0 0 1-1.924 2.85 9.167 9.167 0 0 1-2.85 1.925A8.689 8.689 0 0 1 13 22zm-6-3-6-6 6-6 6 6-6 6z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.63162b735ed45f5a75ed777b3babb7e6.svg";
export { ForwardRef as ReactComponent };